import React from 'react';
import moment from 'moment';
const DateFormat = ({ date, outputFormat }) => {
  return (
    <span>
        {moment(date).format(outputFormat)}        
    </span>    
  );
};

export default DateFormat;
